<template>
  <svg v-if="color_1"
       width="24"
       height="24"
       viewBox="0 0 24 24"
       fill="none"
       xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10.92 2.86819C11.03 2.67935 11.1877 2.52267 11.3772 2.41377C11.5667 2.30487 11.7814 2.24756 12 2.24756C12.2185 2.24756 12.4333 2.30487 12.6228 2.41377C12.8123 2.52267 12.9699 2.67935 13.08 2.86819L15.875 7.66619L21.303 8.84219C21.5165 8.88859 21.7141 8.99014 21.8761 9.13673C22.0382 9.28331 22.159 9.4698 22.2264 9.67762C22.2939 9.88543 22.3058 10.1073 22.2608 10.3211C22.2158 10.5349 22.1155 10.7332 21.97 10.8962L18.27 15.0372L18.83 20.5622C18.8521 20.7798 18.8167 20.9993 18.7274 21.1989C18.6381 21.3985 18.498 21.5712 18.3211 21.6997C18.1442 21.8283 17.9367 21.9082 17.7192 21.9314C17.5018 21.9546 17.2821 21.9204 17.082 21.8322L12 19.5922L6.91799 21.8322C6.7179 21.9204 6.49818 21.9546 6.28074 21.9314C6.0633 21.9082 5.85577 21.8283 5.67886 21.6997C5.50195 21.5712 5.36185 21.3985 5.27255 21.1989C5.18326 20.9993 5.14789 20.7798 5.16999 20.5622L5.72999 15.0372L2.02999 10.8972C1.88421 10.7342 1.78374 10.5359 1.7386 10.3219C1.69346 10.108 1.70523 9.88592 1.77273 9.67795C1.84023 9.46997 1.96111 9.28335 2.12329 9.13669C2.28547 8.99004 2.48329 8.88849 2.69699 8.84219L8.12499 7.66619L10.92 2.86819ZM12 4.98719L9.68699 8.95919C9.59953 9.10912 9.4818 9.23918 9.34131 9.3411C9.20082 9.44303 9.04065 9.51458 8.87099 9.55119L4.37899 10.5242L7.44099 13.9512C7.67499 14.2132 7.78798 14.5612 7.75299 14.9102L7.28999 19.4832L11.496 17.6292C11.6548 17.5592 11.8264 17.5231 12 17.5231C12.1735 17.5231 12.3452 17.5592 12.504 17.6292L16.71 19.4832L16.247 14.9102C16.2294 14.7375 16.248 14.5631 16.3015 14.3979C16.3551 14.2328 16.4424 14.0807 16.558 13.9512L19.621 10.5242L15.129 9.55119C14.9593 9.51458 14.7991 9.44303 14.6587 9.3411C14.5182 9.23918 14.4004 9.10912 14.313 8.95919L12 4.98719Z"
      fill="url(#ai_star_gradient)" />

    <defs>
      <linearGradient id="ai_star_gradient"
                      x1="10"
                      y1="6"
                      x2="10"
                      y2="21.766"
                      gradientUnits="userSpaceOnUse">
        <stop :stop-color="color_1" />
        <stop offset="1" :stop-color="color_2" />
      </linearGradient>
      <linearGradient id="ai_star_gradient"
                      x1="14"
                      y1="2"
                      x2="14"
                      y2="14"
                      gradientUnits="userSpaceOnUse">
        <stop :stop-color="color_1" />
        <stop offset="1" :stop-color="color_2" />
      </linearGradient>
    </defs>
  </svg>

  <svg v-else
       width="24"
       height="24"
       viewBox="0 0 24 24"
       fill="none"
       xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10.92 2.86819C11.03 2.67935 11.1877 2.52267 11.3772 2.41377C11.5667 2.30487 11.7814 2.24756 12 2.24756C12.2185 2.24756 12.4333 2.30487 12.6228 2.41377C12.8123 2.52267 12.9699 2.67935 13.08 2.86819L15.875 7.66619L21.303 8.84219C21.5165 8.88859 21.7141 8.99014 21.8761 9.13673C22.0382 9.28331 22.159 9.4698 22.2264 9.67762C22.2939 9.88543 22.3058 10.1073 22.2608 10.3211C22.2158 10.5349 22.1155 10.7332 21.97 10.8962L18.27 15.0372L18.83 20.5622C18.8521 20.7798 18.8167 20.9993 18.7274 21.1989C18.6381 21.3985 18.498 21.5712 18.3211 21.6997C18.1442 21.8283 17.9367 21.9082 17.7192 21.9314C17.5018 21.9546 17.2821 21.9204 17.082 21.8322L12 19.5922L6.91799 21.8322C6.7179 21.9204 6.49818 21.9546 6.28074 21.9314C6.0633 21.9082 5.85577 21.8283 5.67886 21.6997C5.50195 21.5712 5.36185 21.3985 5.27255 21.1989C5.18326 20.9993 5.14789 20.7798 5.16999 20.5622L5.72999 15.0372L2.02999 10.8972C1.88421 10.7342 1.78374 10.5359 1.7386 10.3219C1.69346 10.108 1.70523 9.88592 1.77273 9.67795C1.84023 9.46997 1.96111 9.28335 2.12329 9.13669C2.28547 8.99004 2.48329 8.88849 2.69699 8.84219L8.12499 7.66619L10.92 2.86819ZM12 4.98719L9.68699 8.95919C9.59953 9.10912 9.4818 9.23918 9.34131 9.3411C9.20082 9.44303 9.04065 9.51458 8.87099 9.55119L4.37899 10.5242L7.44099 13.9512C7.67499 14.2132 7.78798 14.5612 7.75299 14.9102L7.28999 19.4832L11.496 17.6292C11.6548 17.5592 11.8264 17.5231 12 17.5231C12.1735 17.5231 12.3452 17.5592 12.504 17.6292L16.71 19.4832L16.247 14.9102C16.2294 14.7375 16.248 14.5631 16.3015 14.3979C16.3551 14.2328 16.4424 14.0807 16.558 13.9512L19.621 10.5242L15.129 9.55119C14.9593 9.51458 14.7991 9.44303 14.6587 9.3411C14.5182 9.23918 14.4004 9.10912 14.313 8.95919L12 4.98719Z"
      :fill="color" />
  </svg>
</template>
<script>
export default {
  props: {
    color: {
      type: String,
      default: "#899399"
    },
    color_1: null,
    color_2: null
  }
}
</script>
